import React from "react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";

function VariableInput({ disabled, variable, index, onChange, onRemove, t }) {
  const onChangeKey = (value) => {
    const formated_value = value.trim().replace(/[^a-zA-Z0-9\-_\d]/gi, "");

    onChange(formated_value, "key", index);
  };

  return (
    <div className="editor-form-input-box-h">
      <div className="editor-form-input">
        <input
          className="disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed"
          type="text"
          value={variable.key}
          disabled={disabled}
          maxLength="128"
          placeholder={t("editor-utils:key")}
          onChange={(e) => {
            onChangeKey(e.target.value);
          }}
        />
      </div>
      <div className="editor-form-input editor-form-textarea m-r-5">
        <textarea
          className="disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed"
          disabled={disabled}
          type="text"
          rows="1"
          value={variable.value}
          placeholder={t("editor-utils:value")}
          onChange={(e) => {
            onChange(e.target.value, "value", index);
          }}
        />
      </div>

      {!disabled && (
        <div className="variable-input-remove">
          {(variable.key || variable.value) && (
            <i
              className="material-icons editor-multi-icons"
              onClick={() => onRemove(index)}
            >
              delete
            </i>
          )}
        </div>
      )}
    </div>
  );
}

VariableInput.propTypes = {
  disabled: PropTypes.bool,
  variable: PropTypes.object.isRequired,
  index: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation("variable-list")(VariableInput);
